import {SortDirection} from "@renta-apps/athenaeum-toolkit";
import RentaTaskConstants from "@/helpers/RentaTaskConstants";

export default class GetWorkOrderEquipmentRequest {
    public workOrderId: string = RentaTaskConstants.defaultGuid;

    public sortColumnName: string | null = null;

    public sortDirection: SortDirection | null = null;
}